import {Component, Prop} from "vue-property-decorator";
import Modal from "@/assets/common/Modal/Modal.vue";
import ItemSelectModal from "@/assets/common/Modal/ItemSelectModal/ItemSelectModal";

@Component({
    components: {
        Modal
    },
})
export default class WorkItemSelectModal extends ItemSelectModal {
    @Prop({default: () => "作業項目"})
    declare itemKindName: string

    @Prop({default: () => "/work_items"})
    declare apiPath: string;

    @Prop({default: () => true})
    declare multiple: boolean

    get isValid() {
        return !this.required || !!this.selectedValue
    }

    // バリデーションチェックパラメータのオーバーライド
    validateParam = { nameLength: 100 }
}
